// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.TopicListSmall .TopicListSmall-topics {
  display: flex;
}
.TopicListSmall .TopicListSmall-topics span {
  margin: 0 4px 0 0;
}
.TopicListSmall .TopicListSmall-topics span:last-child {
  margin: 0;
}
.TopicListSmall .TopicListSmall-topics h6 {
  background: var(--gray_light2);
  border-radius: 4px;
  color: var(--primary_dark2);
  line-height: 15px;
  font-size: 11px;
  font-weight: normal;
  padding: 1px 8px;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.TopicListSmall .TopicListSmall-topics h6:hover {
  background-color: var(--gray_light1);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/TopicListSmall/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAZE;EACE,aAAA;AAcJ;AAbI;EACE,iBAAA;AAeN;AAbM;EACE,SAAA;AAeR;AAXI;EACE,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EDnBJ,oBAAA;EACA,aCmBwB;EDlBxB,qBCkBwB;EDjBxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACuCtC;AAhBM;EACE,oCAAA;AAkBR","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import '../../mixins.scss';\n\n.TopicListSmall {\n  .TopicListSmall-topics {\n    display: flex;\n    span {\n      margin: 0 4px 0 0;\n\n      &:last-child {\n        margin: 0;\n      }\n    }\n\n    h6 {\n      background: var(--gray_light2);\n      border-radius: 4px;\n      color: var(--primary_dark2);\n      line-height: 15px;\n      font-size: 11px;\n      font-weight: normal;\n      padding: 1px 8px;\n      @include line-clamp(1);\n\n      &:hover {\n        background-color: var(--gray_light1);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
